// extracted by mini-css-extract-plugin
export default {"label":"kizlDrXOm7KTSemIknh0 Fo0ivOPQw4q1xJjcPhw2 PqxDhHCAt16nTk6aDklT"};